<script>
  // Extensions
  import View from '@/views/View'

  // Mixins
  import LoadSections from '@/mixins/load-sections'

  export default {
    name: 'Vizion',

    metaInfo: { title: 'Vizion' },

    extends: View,

    mixins: [
      LoadSections([
        // 'hero-alt',
        'vizion',
      ]),
    ],

    props: {
      id: {
        type: String,
        default: 'vizion',
      },
    },
  }
</script>
